export default "__VITE_ASSET__13C$N$qp__"